import { PF_SERVER_URL } from "../Constants";

export namespace RemoteDataController {
  /**
   * Logs an error remotely to the server to display in nginx error logs
   * @param error
   * @returns
   */
  export async function logError(error: string | Error): Promise<any> {
    try {
      const url = PF_SERVER_URL + "/portfolio/logError";

      console.log(error);

      const response: Response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Error: error instanceof Error ? error.stack : error,
        }),
      });

      if (response) {
        const json = await response.json();

        if (json.success) {
          return true;
        } else {
          return false;
        }
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  }
}

export default RemoteDataController;
